import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ROUTES } from '../definitions/constants/routes.constants';
import { UserConfigsStoreFacade } from '../stores/global-store/user-configs/user-configs-store.facade';

export const appPortalGuard: CanActivateFn = () => {
  const userConfigsFacade = inject(UserConfigsStoreFacade);
  const router = inject(Router);

  if (userConfigsFacade.isSuperAdminSignal()) return true;
  if ((userConfigsFacade.hasReplenishmentOnlyCustomersSignal() || userConfigsFacade.hasHybridCustomersSignal())
    && userConfigsFacade.hasRepEvolutionOnlyCustomersSignal()) return true;

  return router.createUrlTree([ ROUTES.MAIN ]);
};
